import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import KpiAddRequest from '../../../RunPay/Admin/IServices/Models/KPIs/KpiAddRequest';
import KpiChangeRequest from '../../../RunPay/Admin/IServices/Models/KPIs/KpiChangeRequest';
import GetClientHistoryRequest from '../../../RunPay/Admin/IServices/Models/KPIs/GetClientHistoryRequest';
import PaginationRequest from '../../../Common/RequestModels/PaginationRequest';
import EntityIdPaginationRequest from '../../../RunPay/Admin/IServices/Models/Common/EntityIdPaginationRequest';
import GetUserForAddRequest from '../../../RunPay/Admin/IServices/Models/KPIs/GetUserForAddRequest';
import AddUserKpiRequest from '../../../RunPay/Admin/IServices/Models/KPIs/AddUserKpiRequest';
import OptionValueTypeItem from '../../../RunPay/Admin/IServices/Models/KPIs/OptionValueTypeItem';
import WsResponseModel from '../../../SchemaBuilderServer/Models/WsResponseModel';
import KpiShortItemResponse from '../../../RunPay/Admin/IServices/Models/KPIs/KpiShortItemResponse';
import PaginationResponse from '../../../Common/ResponseModels/PaginationResponse';
import ClientHistoryItemResponse from '../../../RunPay/Admin/IServices/Models/KPIs/ClientHistoryItemResponse';
import KpiItemResponse from '../../../RunPay/Admin/IServices/Models/KPIs/KpiItemResponse';
import UserGoalProgressItemResponse from '../../../RunPay/Admin/IServices/Models/KPIs/UserGoalProgressItemResponse';
import UserForAddItemResponse from '../../../RunPay/Admin/IServices/Models/KPIs/UserForAddItemResponse';

export default class KpiService {
	webApiService: WebApiService;
	AddKpiEvent = new Events<WsResponseModel<number>>();
	ChangeKpiEvent = new Events<WsResponseModel<Boolean>>();
	GetSingleKpiEvent = new Events<WsResponseModel<KpiShortItemResponse>>();
	DeleteKpiEvent = new Events<WsResponseModel<Boolean>>();
	GetPaginatedClientHistoryListEvent = new Events<WsResponseModel<PaginationResponse<ClientHistoryItemResponse>>>();
	GetPaginatedKpisListEvent = new Events<WsResponseModel<PaginationResponse<KpiItemResponse>>>();
	GetPaginatedUserGoalProgressListEvent = new Events<WsResponseModel<PaginationResponse<UserGoalProgressItemResponse>>>();
	GetUserForAddingEvent = new Events<WsResponseModel<Array<UserForAddItemResponse>>>();
	AddUserToKpiEvent = new Events<WsResponseModel<number>>();
	ChangeOptionValueTypeEvent = new Events<WsResponseModel<Boolean>>();
	GetOptionValueTypesEvent = new Events<WsResponseModel<Array<OptionValueTypeItem>>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('KpiService', 'AddKpi', (res: WsResponseModel<number>) => {
			self.AddKpiEvent.trigger(res);
		});
		webApiService.on('KpiService', 'ChangeKpi', (res: WsResponseModel<Boolean>) => {
			self.ChangeKpiEvent.trigger(res);
		});
		webApiService.on('KpiService', 'GetSingleKpi', (res: WsResponseModel<KpiShortItemResponse>) => {
			self.GetSingleKpiEvent.trigger(res);
		});
		webApiService.on('KpiService', 'DeleteKpi', (res: WsResponseModel<Boolean>) => {
			self.DeleteKpiEvent.trigger(res);
		});
		webApiService.on('KpiService', 'GetPaginatedClientHistoryList', (res: WsResponseModel<PaginationResponse<ClientHistoryItemResponse>>) => {
			self.GetPaginatedClientHistoryListEvent.trigger(res);
		});
		webApiService.on('KpiService', 'GetPaginatedKpisList', (res: WsResponseModel<PaginationResponse<KpiItemResponse>>) => {
			self.GetPaginatedKpisListEvent.trigger(res);
		});
		webApiService.on('KpiService', 'GetPaginatedUserGoalProgressList', (res: WsResponseModel<PaginationResponse<UserGoalProgressItemResponse>>) => {
			self.GetPaginatedUserGoalProgressListEvent.trigger(res);
		});
		webApiService.on('KpiService', 'GetUserForAdding', (res: WsResponseModel<Array<UserForAddItemResponse>>) => {
			self.GetUserForAddingEvent.trigger(res);
		});
		webApiService.on('KpiService', 'AddUserToKpi', (res: WsResponseModel<number>) => {
			self.AddUserToKpiEvent.trigger(res);
		});
		webApiService.on('KpiService', 'ChangeOptionValueType', (res: WsResponseModel<Boolean>) => {
			self.ChangeOptionValueTypeEvent.trigger(res);
		});
		webApiService.on('KpiService', 'GetOptionValueTypes', (res: WsResponseModel<Array<OptionValueTypeItem>>) => {
			self.GetOptionValueTypesEvent.trigger(res);
		});
	}
	AddKpi(request: KpiAddRequest = null) { 	
        this.webApiService.send('KpiService', 'AddKpi' , request);
    }
	ChangeKpi(request: KpiChangeRequest = null) { 	
        this.webApiService.send('KpiService', 'ChangeKpi' , request);
    }
	GetSingleKpi(id: number = 0) { 	
        this.webApiService.send('KpiService', 'GetSingleKpi' , id);
    }
	DeleteKpi(id: number = 0) { 	
        this.webApiService.send('KpiService', 'DeleteKpi' , id);
    }
	GetPaginatedClientHistoryList(request: GetClientHistoryRequest = null) { 	
        this.webApiService.send('KpiService', 'GetPaginatedClientHistoryList' , request);
    }
	GetPaginatedKpisList(request: PaginationRequest = null) { 	
        this.webApiService.send('KpiService', 'GetPaginatedKpisList' , request);
    }
	GetPaginatedUserGoalProgressList(request: EntityIdPaginationRequest = null) { 	
        this.webApiService.send('KpiService', 'GetPaginatedUserGoalProgressList' , request);
    }
	GetUserForAdding(request: GetUserForAddRequest = null) { 	
        this.webApiService.send('KpiService', 'GetUserForAdding' , request);
    }
	AddUserToKpi(request: AddUserKpiRequest = null) { 	
        this.webApiService.send('KpiService', 'AddUserToKpi' , request);
    }
	ChangeOptionValueType(request: OptionValueTypeItem = null) { 	
        this.webApiService.send('KpiService', 'ChangeOptionValueType' , request);
    }
	GetOptionValueTypes() { 	
        this.webApiService.send('KpiService', 'GetOptionValueTypes' );
    }
	 // async methods
	async addKpiAsync(request: KpiAddRequest = null): Promise<number> {
		return EventToAsyncDecorator.getInstance().bind(this.AddKpi.bind(this), this.AddKpiEvent)(request);
	}
	async changeKpiAsync(request: KpiChangeRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.ChangeKpi.bind(this), this.ChangeKpiEvent)(request);
	}
	async getSingleKpiAsync(id: number = 0): Promise<KpiShortItemResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetSingleKpi.bind(this), this.GetSingleKpiEvent)(id);
	}
	async deleteKpiAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.DeleteKpi.bind(this), this.DeleteKpiEvent)(id);
	}
	async getPaginatedClientHistoryListAsync(request: GetClientHistoryRequest = null): Promise<PaginationResponse<ClientHistoryItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetPaginatedClientHistoryList.bind(this), this.GetPaginatedClientHistoryListEvent)(request);
	}
	async getPaginatedKpisListAsync(request: PaginationRequest = null): Promise<PaginationResponse<KpiItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetPaginatedKpisList.bind(this), this.GetPaginatedKpisListEvent)(request);
	}
	async getPaginatedUserGoalProgressListAsync(request: EntityIdPaginationRequest = null): Promise<PaginationResponse<UserGoalProgressItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetPaginatedUserGoalProgressList.bind(this), this.GetPaginatedUserGoalProgressListEvent)(request);
	}
	async getUserForAddingAsync(request: GetUserForAddRequest = null): Promise<Array<UserForAddItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetUserForAdding.bind(this), this.GetUserForAddingEvent)(request);
	}
	async addUserToKpiAsync(request: AddUserKpiRequest = null): Promise<number> {
		return EventToAsyncDecorator.getInstance().bind(this.AddUserToKpi.bind(this), this.AddUserToKpiEvent)(request);
	}
	async changeOptionValueTypeAsync(request: OptionValueTypeItem = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.ChangeOptionValueType.bind(this), this.ChangeOptionValueTypeEvent)(request);
	}
	async getOptionValueTypesAsync(): Promise<Array<OptionValueTypeItem>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetOptionValueTypes.bind(this), this.GetOptionValueTypesEvent)();
	}
}


// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/Admin/Services/KpiService.ts